export type WorkState =
  | "idle"
  | "listening"
  | "working"
  | "speaking"
  | "waiting"
  | "error";

export interface MockSpace {
  id: string;
  name: string;
  activeWork: number;
}

export interface MockProject {
  id: string;
  name: string;
  color: string;
  kind: "home" | "project";
  spaces: MockSpace[];
}

export const STATE_OPTIONS: Array<{
  id: WorkState;
  label: string;
  caption: string;
}> = [
  { id: "idle", label: "Idle", caption: "logo only" },
  { id: "listening", label: "Listening", caption: "inner pulse" },
  { id: "working", label: "Working", caption: "running rim" },
  { id: "speaking", label: "Speaking", caption: "voice shimmer" },
  { id: "waiting", label: "Waiting", caption: "attention dot" },
  { id: "error", label: "Error", caption: "red rim" },
];

export const MOCK_PROJECTS: MockProject[] = [
  {
    id: "home",
    name: "Home",
    color: "#30D158",
    kind: "home",
    spaces: [
      { id: "home-today", name: "Today", activeWork: 1 },
      { id: "home-scratch", name: "Scratchpad", activeWork: 0 },
      { id: "home-welcome", name: "Welcome", activeWork: 0 },
    ],
  },
  {
    id: "euro",
    name: "Euro",
    color: "#64D2FF",
    kind: "project",
    spaces: [
      { id: "euro-research", name: "Research", activeWork: 2 },
      { id: "euro-release", name: "Release", activeWork: 1 },
      { id: "euro-decisions", name: "Decisions", activeWork: 0 },
    ],
  },
  {
    id: "growth",
    name: "Growth Lab",
    color: "#FF9F0A",
    kind: "project",
    spaces: [
      { id: "growth-funnel", name: "Funnel", activeWork: 0 },
      { id: "growth-copy", name: "Copy", activeWork: 1 },
    ],
  },
  {
    id: "website",
    name: "Website Refresh",
    color: "#BF5AF2",
    kind: "project",
    spaces: [
      { id: "website-hero", name: "Hero", activeWork: 0 },
      { id: "website-assets", name: "Assets", activeWork: 0 },
    ],
  },
];

export const WORK_ITEMS = [
  { id: "research", label: "Researcher reading tabs", colorClass: "bg-accent" },
  { id: "coder", label: "Coder drafting patch", colorClass: "bg-sky-300" },
  { id: "writer", label: "Writer preparing notes", colorClass: "bg-amber-300" },
];
